import * as React from 'react';
import './TaskTypePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITaskTypeReduxFormState, initialTaskTypeState } from "../../../reducers/reactReduxForms/taskType";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as TaskTypeActions from '../../../actions/taskTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { QALookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface ITaskTypePageParams {
    taskTypeId: number;
}

interface ITaskTypePageProps {

    form: Dtos.TaskType & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITaskTypeReduxFormState;

    location: Location;
    taskTypeId: number;
    match: match<ITaskTypePageParams>;
    history: History;

    // From state
    taskType: Dtos.TaskType;
    lookups: Dtos.Lookup[];

    loadingTaskType: boolean;
    loadTaskTypeSuccess: boolean;
    loadTaskTypeFailure: boolean;

    savingTaskType: boolean;
    saveTaskTypeSuccess: boolean;
    saveTaskTypeFailure: boolean;

    creatingTaskType: boolean;
    createTaskTypeSuccess: boolean;
    createTaskTypeFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITaskTypePageActions {
    clearTaskType: TaskTypeActions.ITaskTypeClearActionCreator;
    loadTaskType: TaskTypeActions.ITaskTypeLoadByIdActionCreator;

    saveTaskType: TaskTypeActions.ITaskTypeSaveActionCreator;
    createTaskType: TaskTypeActions.ITaskTypeCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type TaskTypePageProps = ITaskTypePageProps & ITaskTypePageActions;

const reduxFormName: string = "reduxForms.taskType";

class TaskTypePage extends React.PureComponent<TaskTypePageProps, any> {

    constructor(props: TaskTypePageProps) {
        super(props);

        this.clearTaskType = this.clearTaskType.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTaskType,
            taskTypeId,
            createTaskType
        } = this.props;

        if (taskTypeId) {
            loadTaskType(taskTypeId);
        } else if (!taskTypeId) {
            createTaskType();
        }
    }

    componentWillReceiveProps(nextProps: TaskTypePageProps) {
    }

    componentDidUpdate(prevProps: TaskTypePageProps, prevState) {
        const {
            taskTypeId,
            taskType,
            form,
            navigate,
            loadTaskType,
            loadingTaskType,
            loadTaskTypeSuccess,
            createTaskType,
            creatingTaskType,
            createTaskTypeSuccess,
            savingTaskType,
            saveTaskTypeSuccess,
            validationFailures
        } = this.props;

        if (taskTypeId && prevProps.taskTypeId != taskTypeId) {
            loadTaskType(taskTypeId);
        }
        else if (!taskTypeId && prevProps.taskTypeId) {
            createTaskType();
        }

        if (!loadingTaskType && prevProps.loadingTaskType) {
            if (loadTaskTypeSuccess) {
                this.loadForm();
            }
        }

        if (!savingTaskType && prevProps.savingTaskType) {
            if (saveTaskTypeSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/qa/taskTypes")
                } else if (!form.saveAndReturn && taskTypeId && taskTypeId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !taskTypeId && taskType && taskType.id > 0) {
                    navigate("/settings/qa/taskTypes/" + taskType.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingTaskType && prevProps.creatingTaskType) {
            if (createTaskTypeSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(nextProps: TaskTypePageProps) {
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearTaskType();
        loadForm(reduxFormName, initialTaskTypeState);
        resetForm(reduxFormName);
    }

    clearTaskType() {
        this.props.clearTaskType();
    }

    showTaskType(): boolean {
        const {
            loadingTaskType,
            loadTaskTypeSuccess
        } = this.props

        if (!loadingTaskType && loadTaskTypeSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTaskType
        } = this.props;

        return <QALookupsLayout loading={loadingTaskType} permission={Dtos.Permission.TaskTypesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingTaskType,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TaskTypesUpdate, Dtos.Permission.TaskTypesCreate);
        const formDisabled: boolean = !hasPermission || savingTaskType || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Task Type</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "taskType", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.TaskType) {
        const {
            saveTaskType
        } = this.props;

        if (data) {
            let changes: Dtos.TaskType = {} as Dtos.TaskType;
            saveTaskType(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.TaskType) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/qa/taskTypes");
    }

    loadForm() {
        const {
            loadForm,
            taskType,
        } = this.props

        let extraData: Dtos.TaskType = {} as Dtos.TaskType;

        loadForm(reduxFormName, Object.assign({ ...taskType }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: TaskTypePageProps): ITaskTypePageProps => {

    let taskType: Dtos.TaskType | undefined = !(state.taskTypes.formData instanceof Array) ? state.taskTypes.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        taskTypeId: ownProps.match && ownProps.match.params.taskTypeId && ownProps.match.params.taskTypeId.toString() != "create" ? ownProps.match.params.taskTypeId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        taskType: taskType!,

        loadingTaskType: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Pending,
        loadTaskTypeSuccess: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Success,
        loadTaskTypeFailure: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Failure,

        savingTaskType: state.taskTypes.saveState && state.taskTypes.saveState.status == RequestState.Pending,
        saveTaskTypeSuccess: state.taskTypes.saveState && state.taskTypes.saveState.status == RequestState.Success,
        saveTaskTypeFailure: state.taskTypes.saveState && state.taskTypes.saveState.status == RequestState.Failure,

        creatingTaskType: state.taskTypes.createState && state.taskTypes.createState.status == RequestState.Pending,
        createTaskTypeSuccess: state.taskTypes.createState && state.taskTypes.createState.status == RequestState.Success,
        createTaskTypeFailure: state.taskTypes.createState && state.taskTypes.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.taskType,
        formState: state.taskTypes.formState,
        formProperties: state.taskTypes.formProperties,

        reduxFormState: state.reduxForms.formState.taskType,
        validationFailures: taskType ?
            state.taskTypes.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): ITaskTypePageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTaskType: bindActionCreators(TaskTypeActions.LoadTaskTypeById, dispatch),
        clearTaskType: bindActionCreators(TaskTypeActions.Clear, dispatch),

        saveTaskType: bindActionCreators(TaskTypeActions.SaveTaskType, dispatch),
        createTaskType: bindActionCreators(TaskTypeActions.CreateTaskType, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TaskTypePage);
